/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AdminAgentMemo from './AdminAgentMemo';
import AdminAgentTargetConditionPayload from './AdminAgentTargetConditionPayload';
import Agent from './Agent';
import AgentCompatibilityProfile from './AgentCompatibilityProfile';
import AgentCompatibilityRadar from './AgentCompatibilityRadar';
import AgentIntroductionImage from './AgentIntroductionImage';
import AgentMetrics from './AgentMetrics';
import AgentProfileImage from './AgentProfileImage';
import AgentPropallyComment from './AgentPropallyComment';
import AgentSupportedPropertyTypeEnum from './AgentSupportedPropertyTypeEnum';
import AssessmentProposal from './AssessmentProposal';
import Company from './Company';
import ContractApplication from './ContractApplication';
import InvestmentProposal from './InvestmentProposal';
import ProposalMatching from './ProposalMatching';

/**
 * The AgentRequest model module.
 * @module model/AgentRequest
 * @version 1.0.0
 */
class AgentRequest {
    /**
     * Constructs a new <code>AgentRequest</code>.
     * @alias module:model/AgentRequest
     * @implements module:model/Agent
     * @param familyName {String} 
     * @param firstName {String} 
     */
    constructor(familyName, firstName) { 
        Agent.initialize(this);
        AgentRequest.initialize(this, familyName, firstName);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, familyName, firstName) { 
        obj['family_name'] = familyName;
        obj['first_name'] = firstName;
    }

    /**
     * Constructs a <code>AgentRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentRequest} obj Optional instance to populate.
     * @return {module:model/AgentRequest} The populated <code>AgentRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentRequest();
            Agent.constructFromObject(data, obj);

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('company_id')) {
                obj['company_id'] = ApiClient.convertToType(data['company_id'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('password')) {
                obj['password'] = ApiClient.convertToType(data['password'], 'String');
            }
            if (data.hasOwnProperty('password_confirmation')) {
                obj['password_confirmation'] = ApiClient.convertToType(data['password_confirmation'], 'String');
            }
            if (data.hasOwnProperty('family_name')) {
                obj['family_name'] = ApiClient.convertToType(data['family_name'], 'String');
            }
            if (data.hasOwnProperty('first_name')) {
                obj['first_name'] = ApiClient.convertToType(data['first_name'], 'String');
            }
            if (data.hasOwnProperty('phone_number')) {
                obj['phone_number'] = ApiClient.convertToType(data['phone_number'], 'String');
            }
            if (data.hasOwnProperty('profile')) {
                obj['profile'] = ApiClient.convertToType(data['profile'], 'String');
            }
            if (data.hasOwnProperty('beginner_message')) {
                obj['beginner_message'] = ApiClient.convertToType(data['beginner_message'], 'String');
            }
            if (data.hasOwnProperty('last_accessed_at')) {
                obj['last_accessed_at'] = ApiClient.convertToType(data['last_accessed_at'], 'Date');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'Date');
            }
            if (data.hasOwnProperty('is_enabled_notification_new_user')) {
                obj['is_enabled_notification_new_user'] = ApiClient.convertToType(data['is_enabled_notification_new_user'], 'Boolean');
            }
            if (data.hasOwnProperty('is_enabled_notification_new_property')) {
                obj['is_enabled_notification_new_property'] = ApiClient.convertToType(data['is_enabled_notification_new_property'], 'Boolean');
            }
            if (data.hasOwnProperty('is_need_user_notifications')) {
                obj['is_need_user_notifications'] = ApiClient.convertToType(data['is_need_user_notifications'], 'Boolean');
            }
            if (data.hasOwnProperty('is_displayed_in_recommend_feed')) {
                obj['is_displayed_in_recommend_feed'] = ApiClient.convertToType(data['is_displayed_in_recommend_feed'], 'Boolean');
            }
            if (data.hasOwnProperty('is_displayed_in_active_feed')) {
                obj['is_displayed_in_active_feed'] = ApiClient.convertToType(data['is_displayed_in_active_feed'], 'Boolean');
            }
            if (data.hasOwnProperty('is_displayed_in_compatibility_feed')) {
                obj['is_displayed_in_compatibility_feed'] = ApiClient.convertToType(data['is_displayed_in_compatibility_feed'], 'Boolean');
            }
            if (data.hasOwnProperty('is_displayed_in_match_feed')) {
                obj['is_displayed_in_match_feed'] = ApiClient.convertToType(data['is_displayed_in_match_feed'], 'Boolean');
            }
            if (data.hasOwnProperty('is_displayed_in_limited_property')) {
                obj['is_displayed_in_limited_property'] = ApiClient.convertToType(data['is_displayed_in_limited_property'], 'Boolean');
            }
            if (data.hasOwnProperty('supported_property_types')) {
                obj['supported_property_types'] = ApiClient.convertToType(data['supported_property_types'], [AgentSupportedPropertyTypeEnum]);
            }
            if (data.hasOwnProperty('discarded_at')) {
                obj['discarded_at'] = ApiClient.convertToType(data['discarded_at'], 'Date');
            }
            if (data.hasOwnProperty('admin_agent_memo')) {
                obj['admin_agent_memo'] = AdminAgentMemo.constructFromObject(data['admin_agent_memo']);
            }
            if (data.hasOwnProperty('recommendation_level')) {
                obj['recommendation_level'] = ApiClient.convertToType(data['recommendation_level'], 'Number');
            }
            if (data.hasOwnProperty('compatibility_radar')) {
                obj['compatibility_radar'] = AgentCompatibilityRadar.constructFromObject(data['compatibility_radar']);
            }
            if (data.hasOwnProperty('propally_comment')) {
                obj['propally_comment'] = AgentPropallyComment.constructFromObject(data['propally_comment']);
            }
            if (data.hasOwnProperty('agent_compatibility_profile')) {
                obj['agent_compatibility_profile'] = AgentCompatibilityProfile.constructFromObject(data['agent_compatibility_profile']);
            }
            if (data.hasOwnProperty('company')) {
                obj['company'] = Company.constructFromObject(data['company']);
            }
            if (data.hasOwnProperty('agent_profile_image')) {
                obj['agent_profile_image'] = AgentProfileImage.constructFromObject(data['agent_profile_image']);
            }
            if (data.hasOwnProperty('agent_introduction_image')) {
                obj['agent_introduction_image'] = AgentIntroductionImage.constructFromObject(data['agent_introduction_image']);
            }
            if (data.hasOwnProperty('assessment_proposals')) {
                obj['assessment_proposals'] = ApiClient.convertToType(data['assessment_proposals'], [AssessmentProposal]);
            }
            if (data.hasOwnProperty('investment_proposals')) {
                obj['investment_proposals'] = ApiClient.convertToType(data['investment_proposals'], [InvestmentProposal]);
            }
            if (data.hasOwnProperty('proposal_matchings')) {
                obj['proposal_matchings'] = ApiClient.convertToType(data['proposal_matchings'], [ProposalMatching]);
            }
            if (data.hasOwnProperty('contract_applications')) {
                obj['contract_applications'] = ApiClient.convertToType(data['contract_applications'], [ContractApplication]);
            }
            if (data.hasOwnProperty('target_condition')) {
                obj['target_condition'] = ApiClient.convertToType(data['target_condition'], 'String');
            }
            if (data.hasOwnProperty('target_condition_payload')) {
                obj['target_condition_payload'] = AdminAgentTargetConditionPayload.constructFromObject(data['target_condition_payload']);
            }
            if (data.hasOwnProperty('is_matched')) {
                obj['is_matched'] = ApiClient.convertToType(data['is_matched'], 'Boolean');
            }
            if (data.hasOwnProperty('metrics')) {
                obj['metrics'] = AgentMetrics.constructFromObject(data['metrics']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AgentRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['password'] && !(typeof data['password'] === 'string' || data['password'] instanceof String)) {
            throw new Error("Expected the field `password` to be a primitive type in the JSON string but got " + data['password']);
        }
        // ensure the json data is a string
        if (data['password_confirmation'] && !(typeof data['password_confirmation'] === 'string' || data['password_confirmation'] instanceof String)) {
            throw new Error("Expected the field `password_confirmation` to be a primitive type in the JSON string but got " + data['password_confirmation']);
        }
        // ensure the json data is a string
        if (data['family_name'] && !(typeof data['family_name'] === 'string' || data['family_name'] instanceof String)) {
            throw new Error("Expected the field `family_name` to be a primitive type in the JSON string but got " + data['family_name']);
        }
        // ensure the json data is a string
        if (data['first_name'] && !(typeof data['first_name'] === 'string' || data['first_name'] instanceof String)) {
            throw new Error("Expected the field `first_name` to be a primitive type in the JSON string but got " + data['first_name']);
        }
        // ensure the json data is a string
        if (data['phone_number'] && !(typeof data['phone_number'] === 'string' || data['phone_number'] instanceof String)) {
            throw new Error("Expected the field `phone_number` to be a primitive type in the JSON string but got " + data['phone_number']);
        }
        // ensure the json data is a string
        if (data['profile'] && !(typeof data['profile'] === 'string' || data['profile'] instanceof String)) {
            throw new Error("Expected the field `profile` to be a primitive type in the JSON string but got " + data['profile']);
        }
        // ensure the json data is a string
        if (data['beginner_message'] && !(typeof data['beginner_message'] === 'string' || data['beginner_message'] instanceof String)) {
            throw new Error("Expected the field `beginner_message` to be a primitive type in the JSON string but got " + data['beginner_message']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['supported_property_types'])) {
            throw new Error("Expected the field `supported_property_types` to be an array in the JSON data but got " + data['supported_property_types']);
        }
        // validate the optional field `admin_agent_memo`
        if (data['admin_agent_memo']) { // data not null
          AdminAgentMemo.validateJSON(data['admin_agent_memo']);
        }
        // validate the optional field `compatibility_radar`
        if (data['compatibility_radar']) { // data not null
          AgentCompatibilityRadar.validateJSON(data['compatibility_radar']);
        }
        // validate the optional field `propally_comment`
        if (data['propally_comment']) { // data not null
          AgentPropallyComment.validateJSON(data['propally_comment']);
        }
        // validate the optional field `agent_compatibility_profile`
        if (data['agent_compatibility_profile']) { // data not null
          AgentCompatibilityProfile.validateJSON(data['agent_compatibility_profile']);
        }
        // validate the optional field `company`
        if (data['company']) { // data not null
          Company.validateJSON(data['company']);
        }
        // validate the optional field `agent_profile_image`
        if (data['agent_profile_image']) { // data not null
          AgentProfileImage.validateJSON(data['agent_profile_image']);
        }
        // validate the optional field `agent_introduction_image`
        if (data['agent_introduction_image']) { // data not null
          AgentIntroductionImage.validateJSON(data['agent_introduction_image']);
        }
        if (data['assessment_proposals']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['assessment_proposals'])) {
                throw new Error("Expected the field `assessment_proposals` to be an array in the JSON data but got " + data['assessment_proposals']);
            }
            // validate the optional field `assessment_proposals` (array)
            for (const item of data['assessment_proposals']) {
                AssessmentProposal.validateJSON(item);
            };
        }
        if (data['investment_proposals']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['investment_proposals'])) {
                throw new Error("Expected the field `investment_proposals` to be an array in the JSON data but got " + data['investment_proposals']);
            }
            // validate the optional field `investment_proposals` (array)
            for (const item of data['investment_proposals']) {
                InvestmentProposal.validateJSON(item);
            };
        }
        if (data['proposal_matchings']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['proposal_matchings'])) {
                throw new Error("Expected the field `proposal_matchings` to be an array in the JSON data but got " + data['proposal_matchings']);
            }
            // validate the optional field `proposal_matchings` (array)
            for (const item of data['proposal_matchings']) {
                ProposalMatching.validateJSON(item);
            };
        }
        if (data['contract_applications']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contract_applications'])) {
                throw new Error("Expected the field `contract_applications` to be an array in the JSON data but got " + data['contract_applications']);
            }
            // validate the optional field `contract_applications` (array)
            for (const item of data['contract_applications']) {
                ContractApplication.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['target_condition'] && !(typeof data['target_condition'] === 'string' || data['target_condition'] instanceof String)) {
            throw new Error("Expected the field `target_condition` to be a primitive type in the JSON string but got " + data['target_condition']);
        }
        // validate the optional field `target_condition_payload`
        if (data['target_condition_payload']) { // data not null
          AdminAgentTargetConditionPayload.validateJSON(data['target_condition_payload']);
        }
        // validate the optional field `metrics`
        if (data['metrics']) { // data not null
          AgentMetrics.validateJSON(data['metrics']);
        }

        return true;
    }


}

AgentRequest.RequiredProperties = ["family_name", "first_name"];

/**
 * @member {Number} id
 */
AgentRequest.prototype['id'] = undefined;

/**
 * @member {Number} company_id
 */
AgentRequest.prototype['company_id'] = undefined;

/**
 * @member {String} email
 */
AgentRequest.prototype['email'] = undefined;

/**
 * @member {String} password
 */
AgentRequest.prototype['password'] = undefined;

/**
 * @member {String} password_confirmation
 */
AgentRequest.prototype['password_confirmation'] = undefined;

/**
 * @member {String} family_name
 */
AgentRequest.prototype['family_name'] = undefined;

/**
 * @member {String} first_name
 */
AgentRequest.prototype['first_name'] = undefined;

/**
 * @member {String} phone_number
 */
AgentRequest.prototype['phone_number'] = undefined;

/**
 * @member {String} profile
 */
AgentRequest.prototype['profile'] = undefined;

/**
 * はじめて不動産投資をする人に向けた一言（前後の空白を除いて40字まで、超過は422。プランナー本人が入力。「」は画面側で付ける。空白のみ・未入力は null）
 * @member {String} beginner_message
 */
AgentRequest.prototype['beginner_message'] = undefined;

/**
 * @member {Date} last_accessed_at
 */
AgentRequest.prototype['last_accessed_at'] = undefined;

/**
 * @member {Date} created_at
 */
AgentRequest.prototype['created_at'] = undefined;

/**
 * @member {Date} updated_at
 */
AgentRequest.prototype['updated_at'] = undefined;

/**
 * @member {Boolean} is_enabled_notification_new_user
 */
AgentRequest.prototype['is_enabled_notification_new_user'] = undefined;

/**
 * @member {Boolean} is_enabled_notification_new_property
 */
AgentRequest.prototype['is_enabled_notification_new_property'] = undefined;

/**
 * @member {Boolean} is_need_user_notifications
 */
AgentRequest.prototype['is_need_user_notifications'] = undefined;

/**
 * @member {Boolean} is_displayed_in_recommend_feed
 */
AgentRequest.prototype['is_displayed_in_recommend_feed'] = undefined;

/**
 * @member {Boolean} is_displayed_in_active_feed
 */
AgentRequest.prototype['is_displayed_in_active_feed'] = undefined;

/**
 * @member {Boolean} is_displayed_in_compatibility_feed
 */
AgentRequest.prototype['is_displayed_in_compatibility_feed'] = undefined;

/**
 * @member {Boolean} is_displayed_in_match_feed
 */
AgentRequest.prototype['is_displayed_in_match_feed'] = undefined;

/**
 * @member {Boolean} is_displayed_in_limited_property
 */
AgentRequest.prototype['is_displayed_in_limited_property'] = undefined;

/**
 * 対応可能種別一覧
 * @member {Array.<module:model/AgentSupportedPropertyTypeEnum>} supported_property_types
 */
AgentRequest.prototype['supported_property_types'] = undefined;

/**
 * @member {Date} discarded_at
 */
AgentRequest.prototype['discarded_at'] = undefined;

/**
 * @member {module:model/AdminAgentMemo} admin_agent_memo
 */
AgentRequest.prototype['admin_agent_memo'] = undefined;

/**
 * エージェントのおすすめレベル
 * @member {Number} recommendation_level
 */
AgentRequest.prototype['recommendation_level'] = undefined;

/**
 * @member {module:model/AgentCompatibilityRadar} compatibility_radar
 */
AgentRequest.prototype['compatibility_radar'] = undefined;

/**
 * @member {module:model/AgentPropallyComment} propally_comment
 */
AgentRequest.prototype['propally_comment'] = undefined;

/**
 * @member {module:model/AgentCompatibilityProfile} agent_compatibility_profile
 */
AgentRequest.prototype['agent_compatibility_profile'] = undefined;

/**
 * @member {module:model/Company} company
 */
AgentRequest.prototype['company'] = undefined;

/**
 * @member {module:model/AgentProfileImage} agent_profile_image
 */
AgentRequest.prototype['agent_profile_image'] = undefined;

/**
 * @member {module:model/AgentIntroductionImage} agent_introduction_image
 */
AgentRequest.prototype['agent_introduction_image'] = undefined;

/**
 * @member {Array.<module:model/AssessmentProposal>} assessment_proposals
 */
AgentRequest.prototype['assessment_proposals'] = undefined;

/**
 * @member {Array.<module:model/InvestmentProposal>} investment_proposals
 */
AgentRequest.prototype['investment_proposals'] = undefined;

/**
 * @member {Array.<module:model/ProposalMatching>} proposal_matchings
 */
AgentRequest.prototype['proposal_matchings'] = undefined;

/**
 * @member {Array.<module:model/ContractApplication>} contract_applications
 */
AgentRequest.prototype['contract_applications'] = undefined;

/**
 * 対象条件
 * @member {String} target_condition
 */
AgentRequest.prototype['target_condition'] = undefined;

/**
 * @member {module:model/AdminAgentTargetConditionPayload} target_condition_payload
 */
AgentRequest.prototype['target_condition_payload'] = undefined;

/**
 * @member {Boolean} is_matched
 */
AgentRequest.prototype['is_matched'] = undefined;

/**
 * @member {module:model/AgentMetrics} metrics
 */
AgentRequest.prototype['metrics'] = undefined;


// Implement Agent interface:
/**
 * @member {Number} id
 */
Agent.prototype['id'] = undefined;
/**
 * @member {Number} company_id
 */
Agent.prototype['company_id'] = undefined;
/**
 * @member {String} email
 */
Agent.prototype['email'] = undefined;
/**
 * @member {String} password
 */
Agent.prototype['password'] = undefined;
/**
 * @member {String} password_confirmation
 */
Agent.prototype['password_confirmation'] = undefined;
/**
 * @member {String} family_name
 */
Agent.prototype['family_name'] = undefined;
/**
 * @member {String} first_name
 */
Agent.prototype['first_name'] = undefined;
/**
 * @member {String} phone_number
 */
Agent.prototype['phone_number'] = undefined;
/**
 * @member {String} profile
 */
Agent.prototype['profile'] = undefined;
/**
 * はじめて不動産投資をする人に向けた一言（前後の空白を除いて40字まで、超過は422。プランナー本人が入力。「」は画面側で付ける。空白のみ・未入力は null）
 * @member {String} beginner_message
 */
Agent.prototype['beginner_message'] = undefined;
/**
 * @member {Date} last_accessed_at
 */
Agent.prototype['last_accessed_at'] = undefined;
/**
 * @member {Date} created_at
 */
Agent.prototype['created_at'] = undefined;
/**
 * @member {Date} updated_at
 */
Agent.prototype['updated_at'] = undefined;
/**
 * @member {Boolean} is_enabled_notification_new_user
 */
Agent.prototype['is_enabled_notification_new_user'] = undefined;
/**
 * @member {Boolean} is_enabled_notification_new_property
 */
Agent.prototype['is_enabled_notification_new_property'] = undefined;
/**
 * @member {Boolean} is_need_user_notifications
 */
Agent.prototype['is_need_user_notifications'] = undefined;
/**
 * @member {Boolean} is_displayed_in_recommend_feed
 */
Agent.prototype['is_displayed_in_recommend_feed'] = undefined;
/**
 * @member {Boolean} is_displayed_in_active_feed
 */
Agent.prototype['is_displayed_in_active_feed'] = undefined;
/**
 * @member {Boolean} is_displayed_in_compatibility_feed
 */
Agent.prototype['is_displayed_in_compatibility_feed'] = undefined;
/**
 * @member {Boolean} is_displayed_in_match_feed
 */
Agent.prototype['is_displayed_in_match_feed'] = undefined;
/**
 * @member {Boolean} is_displayed_in_limited_property
 */
Agent.prototype['is_displayed_in_limited_property'] = undefined;
/**
 * 対応可能種別一覧
 * @member {Array.<module:model/AgentSupportedPropertyTypeEnum>} supported_property_types
 */
Agent.prototype['supported_property_types'] = undefined;
/**
 * @member {Date} discarded_at
 */
Agent.prototype['discarded_at'] = undefined;
/**
 * @member {module:model/AdminAgentMemo} admin_agent_memo
 */
Agent.prototype['admin_agent_memo'] = undefined;
/**
 * エージェントのおすすめレベル
 * @member {Number} recommendation_level
 */
Agent.prototype['recommendation_level'] = undefined;
/**
 * @member {module:model/AgentCompatibilityRadar} compatibility_radar
 */
Agent.prototype['compatibility_radar'] = undefined;
/**
 * @member {module:model/AgentPropallyComment} propally_comment
 */
Agent.prototype['propally_comment'] = undefined;
/**
 * @member {module:model/AgentCompatibilityProfile} agent_compatibility_profile
 */
Agent.prototype['agent_compatibility_profile'] = undefined;
/**
 * @member {module:model/Company} company
 */
Agent.prototype['company'] = undefined;
/**
 * @member {module:model/AgentProfileImage} agent_profile_image
 */
Agent.prototype['agent_profile_image'] = undefined;
/**
 * @member {module:model/AgentIntroductionImage} agent_introduction_image
 */
Agent.prototype['agent_introduction_image'] = undefined;
/**
 * @member {Array.<module:model/AssessmentProposal>} assessment_proposals
 */
Agent.prototype['assessment_proposals'] = undefined;
/**
 * @member {Array.<module:model/InvestmentProposal>} investment_proposals
 */
Agent.prototype['investment_proposals'] = undefined;
/**
 * @member {Array.<module:model/ProposalMatching>} proposal_matchings
 */
Agent.prototype['proposal_matchings'] = undefined;
/**
 * @member {Array.<module:model/ContractApplication>} contract_applications
 */
Agent.prototype['contract_applications'] = undefined;
/**
 * 対象条件
 * @member {String} target_condition
 */
Agent.prototype['target_condition'] = undefined;
/**
 * @member {module:model/AdminAgentTargetConditionPayload} target_condition_payload
 */
Agent.prototype['target_condition_payload'] = undefined;
/**
 * @member {Boolean} is_matched
 */
Agent.prototype['is_matched'] = undefined;
/**
 * @member {module:model/AgentMetrics} metrics
 */
Agent.prototype['metrics'] = undefined;




export default AgentRequest;

